import { createStore, createEvent } from 'effector'

// Events
const setIsConfirmRecoveryCodeChecked = createEvent<boolean>()

// Stores
const $isConfirmRecoveryCodeChecked = createStore<boolean>(false)

// Store updates
$isConfirmRecoveryCodeChecked.on(setIsConfirmRecoveryCodeChecked, (state, isChecked) => isChecked)

export { $isConfirmRecoveryCodeChecked, setIsConfirmRecoveryCodeChecked }
